import React, { useMemo } from 'react';
import { Alert, Badge, Button } from 'react-bootstrap';
import { getBadgeVariantBy, ReqStatus } from './ReqStatus';
import { ReqUser } from './ReqUser';
import { formatDateTime, isNeedExtData } from '../../../util';

import './request-info.css';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { ExpandableCard } from '../../common/ExpandableCard/ExpandableCard';

export function RequestInfo(props) {
    const { request } = props;
    const showExtDataAlert = useMemo(() => {
        if (!request) return false;
        return request.status.id === 3 && isNeedExtData(request);
    }, [request]);

    return (
        <ExpandableCard
            title={`Заявка № ${request.num}, ${request.nomination.name}`}
            border={getBadgeVariantBy(request.status.id)}
        >
            {showExtDataAlert && (
                <Alert variant="danger">
                    Просьба заполнить доп данные по заявке!
                    <Button
                        className="px-3 ml-3"
                        as={HashLink}
                        to={`#extData`}
                        size="sm"
                        variant="outline-primary"
                        title="Заполнить доп данные"
                        smooth
                    >
                        ↓ К доп данным! ↓
                    </Button>
                </Alert>
            )}
            {request.room && (
                <Alert variant="info">
                    Ваша заявка прикреплена к гримерке <Badge variant="info">{request.room.name}</Badge>!
                    <Button
                        variant="outline-info"
                        as={Link}
                        to={`room`}
                        size="sm"
                        title="Гримерка"
                        className="px-3 ml-3"
                    >
                        Подробней о гримерке
                    </Button>
                </Alert>
            )}
            <div className="request-info-block">
                <span>
                    Автор: <ReqUser user={request.author} />
                </span>
                <span>
                    Статус: <ReqStatus status={request.status} />
                </span>
                <span>Создана: {formatDateTime(request.regDate)}</span>
                <span>Изменена: {formatDateTime(request.modifiedDate)}</span>
            </div>
        </ExpandableCard>
    );
}
